import React from 'react';
import { Link } from 'react-router-dom';
type Props = {
	id: string;
	created: string;
	patientId: string;
	type: 'Prescription' | 'Recipe';
};

const typeTranslater = (type: 'Prescription' | 'Recipe') => {
	if (type === 'Prescription') {
		return 'نسخه با عکس';
	}
	return 'نسخه آنلاین';
};
export const PatientHistoryItem: React.FunctionComponent<Props> = (props) => {
	const { id, created, patientId, type } = props;
	// const date = new Date(created).toLocaleDateString('fa');
	const date = new Date(created).toLocaleDateString('fa');

	return (
		<div
			className="container flex justify-between px-6 mx-auto my-2 rounded-md filter drop-shadow-lg h-14 bg-blue-320 "
			id="pc_card"
		>
			<div className="my-auto text-right text-white text-bold ">
				تاریخ: <span className="mr-3 text-gray-300 text-md">{date}</span>
				<span
					className={`w-12 p-1 mx-4 ${
						type === 'Recipe' ? 'bg-green-800' : 'bg-green-500'
					} rounded-md shadow-md `}
				>
					{typeTranslater(type)}
				</span>
			</div>

			<Link
				to={
					type === 'Prescription'
						? `/patient/${patientId}/prescription/${id}`
						: `/patient/${patientId}/recipe/${id}`
				}
				className="w-4/12 my-1 text-lg text-center text-white rounded-lg bg-cyan-600 sm:my-auto sm:w-3/12 sm:h-4/6 hover:bg-blue-400"
			>
				مشاهده نسخه
			</Link>
		</div>
	);
};
